let fieldConfig = {
    version: 5.5,
    profileType: '145',
    queryForm: [
        {
            label: '纳税人识别号',
            selected: true,
            default: true,
            name: 'taxNo',
        },
        {
            label: '纳税人名称',
            selected: true,
            default: true,
            name: 'companyName',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            name: 'departmentNo',
            dict: 'department_no',
            type: 'departmentNo',
        },
        {
            label: '所属区域',
            selected: false,
            default: false,
            name: 'regionName',
            type: 'regionNo',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            name: 'cityName',
            type: 'managerCityNo',
        },
        {
            label: '主管税局省(市)',
            selected: false,
            default: false,
            name: 'province',
            type: 'taxBureauId',
        },
        {
            label: '税种',
            selected: false,
            default: false,
            name: 'taxType',
            dict: 'sb_tax_type',
            type: 'dict',
        },
        {
            label: '异常类型',
            selected: false,
            default: false,
            name: 'taskType',
            dict: 'sb_abnormal_type',
            type: 'dict',
        },
        {
            label: '跟进人',
            selected: false,
            default: false,
            type: 'follower',
        },
    ],
    table: [
        {
            label: '税种',
            selected: true,
            default: false,
            name: 'taxType',
            dict: 'sb_tax_type',
            type: 'dict',
            sort: false,
        },
        {
            label: '事业部',
            selected: true,
            default: false,
            name: 'departmentNo',
            dict: 'department_no',
            type: 'dict',
            sort: false,
        },
        {
            label: '所属区域',
            selected: true,
            default: false,
            name: 'regionName',
            type: 'specialDict',
            specialDict: 'belleRegionList',
            sort: false,
        },
        {
            label: '管理城市',
            selected: true,
            default: false,
            name: 'cityName',
            sort: false,
        },
        {
            label: '主管税局所在省（市）',
            selected: true,
            default: false,
            name: 'province',
            sort: false,
        },
        {
            label: '纳税人识别号',
            selected: true,
            default: false,
            name: 'taxNo',
            sort: false,
        },
        {
            label: '纳税人名称',
            selected: true,
            default: false,
            name: 'companyName',
            sort: false,
        },
        {
            label: '税局异常信息提示',
            selected: true,
            default: false,
            name: 'informationTips',
            sort: false,
        },
        {
            label: '申报状态',
            selected: true,
            default: false,
            name: 'declarationStatus',
            dict: 'glsale_declaration',
            type: 'dict',
            sort: false,
        },
        {
            label: '缴款状态',
            selected: true,
            default: false,
            name: 'paymentStatus',
            dict: 'glsale_pay',
            type: 'dict',
            sort: false,
        },
        {
            label: '发票采集状态',
            selected: true,
            default: false,
            name: 'acquisitionStatus',
            dict: 'glsale_acquisition',
            type: 'dict',
            sort: false,
        },
        {
            label: '申报填入状态',
            selected: true,
            default: false,
            name: 'fillInStatus',
            dict: 'glsale_fillInStatus',
            type: 'dict',
            sort: false,
        },
        {
            label: '财务报表异常信息提示',
            selected: true,
            default: false,
            name: 'financeErrorInfo',
            sort: false,
        },
        {
            label: '财务报表报送状态',
            selected: true,
            default: false,
            name: 'financeFillInStatus',
            dict: 'enterprise_fillInStatus',
            type: 'dict',
            sort: false,
        },
        {
            label: '人员信息报送状态',
            selected: true,
            default: false,
            name: 'personStatus',
            dict: 'task_personStatus',
            type: 'dict',
            sort: false,
        },
        {
            label: '人员信息报送结果',
            selected: true,
            default: false,
            name: 'personResult',
            sort: false,
        },
        {
            label: '所得项目明细表提交状态',
            selected: true,
            default: false,
            name: 'salaryStatus',
            dict: 'task_salaryStatus',
            type: 'dict',
            sort: false,
        },
        {
            label: '所得项目明细表提交结果',
            selected: true,
            default: false,
            name: 'salaryResult',
            sort: false,
        },
        {
            label: '完税证明下载状态',
            selected: true,
            default: false,
            name: 'taxCertificateStatus',
            dict: 'voucher_download_status',
            type: 'dict',
            sort: false,
        },
        {
            label: '跟进人',
            selected: false,
            default: false,
            // name: ['employeeName','employeeNumber'],
            type: 'follower',
            sort: false,
        },
    ],
}

export default fieldConfig



// WEBPACK FOOTER //
// ./src/app/declaration/declareASummary/abnormalTaskTracking/fieldConfig.js